// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"53":"0a24446c","242":"319ff216","706":"3f9f5c8b","947":"f6d1fc63"}[chunkId] + ".chunk.css";
};